import { getIdToken } from "user-management/src/cognito/kahunUserAuth";

const ASSET_MANAGER_LAMBDA_END_POINT =
  process.env.NODE_ENV !== "production"
    ? "assets-manager-dev.kahun.com"
    : "assets-manager.kahun.com";

export const readFileAsArrayBuffer = (file: File) =>
  new Promise<any>((resolve, reject) => {
    try {
      const fileReader = new FileReader();
      fileReader.onloadend = (e) => resolve(fileReader.result);
      fileReader.onerror = (e) => reject(e);
      fileReader.readAsArrayBuffer(file);
    } catch (e) {
      reject(e);
    }
  });

export const doesAssetExist = async (filePath: string) => {
  return await fetch(filePath, {
    method: "HEAD",
  })
    .then((res) => res.ok)
    .catch((e) => false);
};

export const getSignedS3UploadUrl = async (filePathAndName) => {
  return fetch(
    `https://${ASSET_MANAGER_LAMBDA_END_POINT}/upload/${encodeURIComponent(
      filePathAndName,
    )}`,
    {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: `Bearer ${await getIdToken()}`,
      },
    },
  )
    .then((response) => {
      console.log("Got response from");
      return response.json();
    })
    .then((res) => res.uploadURL)
    .catch((error) => {
      console.error(
        "Failed to get singed upload url for file",
        filePathAndName,
      );
      return null;
    });
};

export const uploadFileToS3 = async (file: File, _fileName: string = null) => {
  const fileName =
    _fileName ||
    file.name ||
    parseInt(String(Math.random() * 10000000)).toString();
  const uploadUrl = await getSignedS3UploadUrl(fileName);
  const body = new Blob([new Uint8Array(await readFileAsArrayBuffer(file))], {
    type: file.type,
  });
  return fetch(uploadUrl, {
    method: "PUT",
    mode: "cors",
    body,
    headers: { "Content-Type": body.type },
    redirect: "follow",
  }).then((response) => response.ok);
};

export const deleteFileFromS3 = async (filePath) => {
  return fetch(
    `https://${ASSET_MANAGER_LAMBDA_END_POINT}/delete/${encodeURIComponent(
      filePath,
    )}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${await getIdToken()}`,
      },
    },
  )
    .then((response) => {
      console.log("Got response from");
      return response.ok;
    })
    .catch((e) => {
      console.error(e);
      return false;
    });
};
